import type { MutableRefObject, Ref, RefCallback } from 'react';

/**
 * Assigns a value to a React ref (callback or object ref).
 */
export function setForwardedRef<T>(ref: Ref<T> | undefined | null, value: T | null): void {
  if (ref == null) return;
  if (typeof ref === 'function') {
    ref(value);
  } else {
    (ref as MutableRefObject<T | null>).current = value;
  }
}

/**
 * Merges multiple refs into a single callback ref.
 * Handles both ref objects (RefObject) and callback refs.
 */
export function mergeRefs<T>(...refs: Array<Ref<T> | undefined | null>): RefCallback<T> {
  return (value: T | null) => {
    for (const ref of refs) {
      setForwardedRef(ref, value);
    }
  };
}
